<template>
    <div v-if="banners.length > 0" class="carousel mb-5">
        <div class="slides">
            <Banner
                v-for="(banner, index) in banners"
                :key="banner.id"
                :banner="banner"
                :isActive="index === currentSlide"
            />
        </div>
    </div>
    <slot v-else-if="hasFetched" />
</template>

<script>
    import api from "@/services/api";
    import Banner from "../components/Banner.vue";

    export default {
        components: {
            Banner,
        },
        data() {
            return {
                banners: [],
                currentSlide: 0,
                slideInterval: null,
                hasFetched: false,
            }
        },
        mounted() {
            this.fetchBanners();
        },
        beforeUnmount() {
            if (this.slideInterval) {
                clearInterval(this.slideInterval);
            }
        },
        methods: {
            fetchBanners: function() {
                api
                .get('/api/v1/banner/getAllActive')
                .then((response) => {
                    this.banners = response.data;
                    this.hasFetched = true;
                    if (this.banners.length > 1) {
                        this.slideInterval = setInterval(function(){
                            this.nextSlide();
                        }.bind(this), 7000);
                    }
                })
                .catch(() => {
                    this.hasFetched = true;
                    console.log('Retrieving banners failed');
                });
            },
            nextSlide: function() {
                this.currentSlide++;
                if (this.currentSlide >= this.banners.length) {
                    this.currentSlide = 0;
                }
            },
        },
    }
</script>

<style scoped lang="scss">

    .carousel
    {
        display: none;
        color: $white;
        background: rgba(53, 57, 67, 1);
        border-radius: 10px;

        @include media-breakpoint-up(xl)
        {
            display: block;
        }
    }

    .slides
    {
        position: relative;
        min-height: 320px;
        background: rgb(64,75,85);
        background: linear-gradient(180deg, rgba(53, 57, 67, 1) 0%, rgba(81, 125, 140, 1) 100%);
        border-radius: 10px;
    }
</style>
